import React from 'react';
import { Phone } from 'lucide-react';
import useReveal, { reveal } from '../../hooks/useReveal';
import { CONTACT } from '../../data/site';

/*
  The one dark band on the page. It sits directly above the footer, which is
  also dark, so the page reads as light throughout and then closes on a single
  deliberate block rather than flipping theme mid-scroll.
*/
const FinalCta = () => {
  const [ref, isVisible] = useReveal({ threshold: 0.3 });

  const scrollToDemo = () =>
    document.getElementById('demo-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  return (
    <section className="ab-final" ref={ref} aria-labelledby="ab-final-title">
      <div className={`ab-shell ab-final__inner ${reveal(isVisible)}`}>
        <div>
          <h2 className="ab-h2 ab-final__title" id="ab-final-title">
            Ready to transform your school?
          </h2>
          <p className="ab-final__body">
            Bring your records, communication and payments together, and give your team back the
            hours they spend chasing paper.
          </p>
        </div>

        <div className="ab-final__actions">
          <button type="button" className="ab-btn ab-btn--onDark" onClick={scrollToDemo}>
            Book a demo
          </button>
          <a href={CONTACT.phoneHref} className="ab-btn ab-btn--onDarkGhost">
            <Phone size={17} strokeWidth={1.75} />
            {CONTACT.phoneDisplay}
          </a>
        </div>
      </div>

      <style jsx>{`
        .ab-final {
          position: relative;
          padding-block: clamp(3.5rem, 6vw, 5.5rem);
          background: var(--ab-navy);
          overflow: clip;
        }

        .ab-final::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(
            60% 100% at 84% 0%,
            rgba(10, 114, 191, 0.42) 0%,
            rgba(10, 114, 191, 0) 70%
          );
          pointer-events: none;
        }

        .ab-final__inner {
          position: relative;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: clamp(1.75rem, 4vw, 3.5rem);
        }

        .ab-final__title {
          color: #fff;
          max-width: 18ch;
        }

        .ab-final__body {
          margin-top: 0.875rem;
          font-size: 1.0625rem;
          line-height: 1.6;
          /* 7.2:1 against the navy. */
          color: rgba(255, 255, 255, 0.78);
          max-width: 46ch;
        }

        .ab-final__actions {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
        }

        @media (max-width: 560px) {
          .ab-final__actions { width: 100%; flex-direction: column; }
        }
      `}</style>
    </section>
  );
};

export default FinalCta;
